<ngx-spinner></ngx-spinner>
<router-outlet></router-outlet>

<!-- Dialog de sem conexão — fora do CDK overlay -->
<div class="sem-conexao-overlay" *ngIf="semConexao">
    <div class="sem-conexao-container">
        <span class="material-icons sem-conexao-icon">wifi_off</span>
        <h2 class="sem-conexao-titulo">Sem conexão com a internet</h2>
        <p class="sem-conexao-mensagem">
            Conexão ruim ou indisponível.<br />
            Quando reestabelecer, clique no botão abaixo.
        </p>
        <button mat-raised-button color="primary" class="sem-conexao-btn" [disabled]="verificandoConexao"
            (click)="verificarConexao()">
            <mat-icon *ngIf="!verificandoConexao">refresh</mat-icon>
            <mat-progress-spinner *ngIf="verificandoConexao" diameter="20" mode="indeterminate" color="accent">
            </mat-progress-spinner>
            {{ verificandoConexao ? 'Verificando...' : 'Estou conectado, continuar' }}
        </button>
        <p *ngIf="semConexaoAposVerificar" class="sem-conexao-erro">
            ⚠️ Ainda sem conexão. Verifique seu Wi-Fi ou dados móveis.
        </p>
    </div>
</div>